import React, { useState } from "react";
import { Box, styled } from "@mui/material";

import { Button, Modal, Tooltip, Tabs } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";

import TabSumber from "./TabSumber";
import TabMetode from "./TabMetode";
import TabHowTo from "./TabHowTo";

const ButtonContainer = styled(Box)(
  ({ theme }) => `
        position: absolute;
        z-index:2;
        right: 12px;
        top: 72px;
        color: white;
        transition: 0.8s;
    `
);

const App = () => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonContainer>
      <Tooltip title="Lihat Info Data Demnas">
        <Button
          type="primary"
          onClick={() => setOpen(true)}
          icon={<InfoCircleFilled />}
        >
          Info Data Demnas
        </Button>
      </Tooltip>
      <Modal
        title="Info Data Demnas"
        centered
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={1000}
        footer={
          <Button type="primary" onClick={() => setOpen(false)}>
            Tutup
          </Button>
        }
      >
        <Tabs
          defaultActiveKey="1"
          items={[
            {
              label: "Sumber Data",
              key: "1",
              children: <TabSumber />,
            },
            {
              label: "Metode",
              key: "2",
              children: <TabMetode />,
            },
            {
              label: "How To",
              key: "3",
              children: <TabHowTo />,
            },
          ]}
        />
      </Modal>
    </ButtonContainer>
  );
};
export default App;
